import { render, staticRenderFns } from "./ClosedTradeTable.vue?vue&type=template&id=3e556868&scoped=true&"
import script from "./ClosedTradeTable.vue?vue&type=script&lang=js&"
export * from "./ClosedTradeTable.vue?vue&type=script&lang=js&"
import style0 from "./ClosedTradeTable.vue?vue&type=style&index=0&id=3e556868&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e556868",
  null
  
)

export default component.exports